import { Infoblock } from '@main/infoblock/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { InfoblockState, StateWithInfoblock } from '../infoblock-state';
import { getInfoblockFeatureState } from './feature.selector';

export const getState: MemoizedSelector<StateWithInfoblock, InfoblockState> = createSelector(
  getInfoblockFeatureState,
  (state: InfoblockState) => state,
);

export const getClosedInfoblockItems: MemoizedSelector<StateWithInfoblock, string[]> = createSelector(
  getState,
  (state) => state.closed,
);

export const getInfoblockItemsState: (
  cityId: string,
) => MemoizedSelector<StateWithInfoblock, StateUtils.LoaderState<Infoblock[]>> = (
  cityId: string,
): MemoizedSelector<StateWithInfoblock, StateUtils.LoaderState<Infoblock[]>> =>
  createSelector(getState, (state: InfoblockState) =>
    StateUtils.entityLoaderStateSelector<Infoblock[]>(state.items, cityId),
  );

export const getInfoblockItemsValue: (cityId: string) => MemoizedSelector<StateWithInfoblock, Infoblock[]> = (
  cityId: string,
): MemoizedSelector<StateWithInfoblock, Infoblock[]> =>
  createSelector(getState, (state: InfoblockState) => StateUtils.entityValueSelector<Infoblock[]>(state.items, cityId));
